import React from 'react';
import styled from 'styled-components';
import Contact from '../components/Contact';

const PageStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const ContactPage = () => (
  <PageStack>
    <Contact />
  </PageStack>
);

export default ContactPage;

